(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["packsys-bag-selector"] && !Shopify.designMode) return;
  try {
    function packsysIsBagCount(total) {
  return Number.isSafeInteger(total) && total >= 10 && total <= 1000000 && total % 10 === 0;
}

function packsysStepBagCount(value, direction) {
  if (!Number.isFinite(value) || value < 10) return 10;
  const next = direction > 0 ? (Math.floor(value / 10) + 1) * 10 : (Math.ceil(value / 10) - 1) * 10;
  return Math.min(1000000, Math.max(10, next));
}

function packsysBuildBagPlan(variants, specification, total) {
  if (!packsysIsBagCount(total)) return null;
  const sizes = [100, 50, 30, 10];
  const matching = variants.filter((variant) => variant.option1 === specification);
  const packs = sizes.map((size) => ({ size, variant: matching.find((variant) => Number.parseInt(variant.option2, 10) === size) }))
    .filter((pack) => pack.variant && Number.isSafeInteger(pack.variant.price) && pack.variant.price > 0);
  const base = packs.find((pack) => pack.size === 10)?.variant;
  if (!base) return null;
  const units = total / 10;
  const costs = new Float64Array(units + 1).fill(Infinity);
  const choices = new Int16Array(units + 1).fill(-1);
  costs[0] = 0;
  for (let amount = 1; amount <= units; amount++) {
    for (let index = 0; index < packs.length; index++) {
      const packUnits = packs[index].size / 10;
      if (packUnits > amount) continue;
      const cost = costs[amount - packUnits] + packs[index].variant.price;
      if (cost < costs[amount]) { costs[amount] = cost; choices[amount] = index; }
    }
  }
  if (!Number.isSafeInteger(costs[units])) return null;
  const quantities = new Array(packs.length).fill(0);
  for (let remaining = units; remaining > 0;) {
    const index = choices[remaining];
    if (index < 0) return null;
    quantities[index]++;
    remaining -= packs[index].size / 10;
  }
  const items = packs.flatMap((pack, index) => quantities[index] ? [{ id: pack.variant.id, quantity: quantities[index], size: pack.size, variant: pack.variant }] : []);
  return { total, price: costs[units], saving: Math.max(0, base.price * units - costs[units]), base,
    available: items.every((item) => item.variant.available), items };
}

function packsysBagsInCart(variants, specification, cartItems) {
  return cartItems.reduce((total, item) => {
    const variant = variants.find((entry) => String(entry.id) === String(item.variant_id));
    if (!variant || variant.option1 !== specification) return total;
    const size = Number.parseInt(variant.option2, 10);
    return total + (Number.isSafeInteger(size) ? size * item.quantity : 0);
  }, 0);
}

if (!customElements.get('packsys-bag-selector')) {
  customElements.define('packsys-bag-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-bag-variants]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-bag-strings]').textContent);
      this.stock = JSON.parse(this.querySelector('[data-bag-stock]').textContent);
      this.cartItems = JSON.parse(this.querySelector('[data-bag-cart]').textContent);
      this.input = this.querySelector('[data-bag-quantity]');
      this.form = this.querySelector('.packsys-bags-form');
      this.button = this.querySelector('[data-bag-submit]');
      this.error = this.querySelector('[data-bag-error]');
      this.helpEmail = this.closest('product-info')?.querySelector('[data-packsys-help-email]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: this.dataset.currency, minimumFractionDigits: 2, maximumFractionDigits: 2
      });
      const initial = this.variants.find((variant) => String(variant.id) === this.dataset.initialVariant) || this.variants[0];
      const checked = Array.from(this.querySelectorAll('input[type="radio"]')).find((input) => input.value === initial.option1);
      if (checked) checked.checked = true;
      const requested = new URL(window.location.href).searchParams.get('bags');
      if (requested && Number.isSafeInteger(Number(requested)) && Number(requested) > 0 && Number(requested) <= 1000000) this.input.value = requested;
      this.form.addEventListener('input', (event) => { if (event.target === this.input) this.render(true); });
      this.input.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return;
        event.preventDefault();
        this.input.value = packsysStepBagCount(Number(this.input.value), event.key === 'ArrowUp' ? 1 : -1);
        this.render(true);
      });
      this.form.addEventListener('change', (event) => { if (event.target.matches('input[type="radio"]')) this.render(true, true); });
      this.form.addEventListener('click', (event) => {
        const preset = event.target.closest('[data-bag-preset]');
        const step = event.target.closest('[data-step]');
        if (preset) this.input.value = preset.dataset.bagPreset;
        if (step) this.input.value = packsysStepBagCount(Number(this.input.value), Number(step.dataset.step));
        if (preset || step) this.render(true);
      });
      this.form.addEventListener('submit', (event) => this.addToCart(event));
      this.render(false);
    }

    text(key, replacements) {
      let result = this.strings[key];
      for (const [name, value] of Object.entries(replacements || {})) result = result.replaceAll('__' + name.toUpperCase() + '__', String(value));
      return result;
    }

    render(updateURL, updateMedia) {
      if (this.busy) return;
      const specification = this.querySelector('input[type="radio"]:checked')?.value;
      const total = Number(this.input.value);
      this.plan = packsysBuildBagPlan(this.variants, specification, total);
      if (this.plan) {
        const stock = this.stock[this.plan.base.id];
        const cartBags = packsysBagsInCart(this.variants, specification, this.cartItems);
        if (stock?.tracked && total + cartBags > Math.max(0, stock.quantity) * 10) this.plan.available = false;
      }
      this.querySelector('[data-step="-1"]').disabled = Number.isFinite(total) && total <= 10;
      this.querySelector('[data-step="1"]').disabled = total >= 1000000;
      const valid = !!this.plan;
      this.input.setAttribute('aria-invalid', String(!valid));
      this.error.hidden = valid;
      this.error.textContent = valid ? '' : this.strings.invalid;
      if (!valid && Number.isSafeInteger(total) && total > 10 && total < 1000000 && total % 10 !== 0) {
        this.error.textContent = this.text('invalidMultiple', { lower: Math.floor(total / 10) * 10, upper: Math.ceil(total / 10) * 10 });
      }
      this.button.disabled = !valid || !this.plan.available;
      this.querySelector('[data-bag-cart-check]').hidden = true;
      for (const preset of this.querySelectorAll('[data-bag-preset]')) {
        const size = Number(preset.dataset.bagPreset);
        preset.setAttribute('aria-pressed', String(valid && size === this.plan.total));
        const badge = preset.querySelector('[data-preset-saving]');
        if (badge) {
          const presetPlan = packsysBuildBagPlan(this.variants, specification, size);
          const percent = presetPlan ? Math.round(100 * presetPlan.saving / (presetPlan.price + presetPlan.saving)) : 0;
          badge.hidden = percent <= 0;
          badge.textContent = this.text('percent', { percent: percent });
        }
      }
      if (!valid) {
        this.querySelector('[data-bag-label]').textContent = this.strings.quantity;
        this.button.textContent = this.strings.chooseQuantity;
        this.querySelector('[data-bag-total]').textContent = '—';
        this.querySelector('[data-bag-unit]').textContent = '';
        this.querySelector('[data-bag-saving]').hidden = true;
        this.querySelector('[data-bag-packing]').textContent = '';
        this.querySelector('[data-bag-availability]').hidden = true;
        if (this.helpEmail) this.helpEmail.href = 'mailto:info@packsys.us';
        return;
      }
      const plan = this.plan;
      this.form.querySelector('[name="id"]').value = plan.items[0].id;
      this.querySelector('[data-bag-label]').textContent = plan.total === 1 ? this.strings.one : this.text('bags', { count: plan.total });
      this.querySelector('[data-bag-total]').textContent = this.money.format(plan.price / 100) + ' ' + this.dataset.currency;
      this.querySelector('[data-bag-unit]').textContent = this.text('unit', { price: this.money.format(plan.price / plan.total / 100) });
      const saving = this.querySelector('[data-bag-saving]');
      saving.hidden = plan.saving <= 0;
      saving.textContent = this.text('saving', { amount: this.money.format(plan.saving / 100) });
      this.querySelector('[data-bag-packing]').textContent = this.text('packing', {
        packs: plan.items.map((item) => this.text('pack', { quantity: item.quantity, size: item.size })).join(' + ')
      });
      this.querySelector('[data-bag-availability]').hidden = plan.available;
      this.button.textContent = plan.total === 1 ? this.strings.addOne : this.text('add', { count: plan.total });
      if (this.helpEmail) {
        const productURL = new URL(this.dataset.productUrl, window.location.origin);
        productURL.searchParams.set('variant', plan.items[0].id);
        productURL.searchParams.set('bags', plan.total);
        this.helpEmail.href = 'mailto:info@packsys.us?subject=' + encodeURIComponent(this.strings.quoteSubject) +
          '&body=' + encodeURIComponent(this.text('quoteBody', { specification: specification, count: plan.total, url: productURL.href }));
      }
      if (updateURL) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', plan.items[0].id);
        url.searchParams.set('bags', plan.total);
        window.history.replaceState({}, '', url);
      }
      if (updateMedia) {
        const media = plan.items[0].variant.featured_media;
        if (media?.id) this.closest('product-info')?.querySelector('media-gallery')?.setActiveMedia?.(this.dataset.sectionId + '-' + media.id, true);
      }
    }

    async addToCart(event) {
      event.preventDefault();
      if (this.busy) return;
      this.render(false);
      if (!this.plan || !this.plan.available) { this.input.focus(); return; }
      const specification = this.querySelector('input[type="radio"]:checked')?.value;
      const plan = this.plan;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.strings.adding;
      this.form.setAttribute('aria-busy', 'true');
      const controls = Array.from(this.form.querySelectorAll('input, button'));
      controls.forEach((control) => { control.disabled = true; });
      try {
        const cartResponse = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error(this.strings.error);
        const cart = await cartResponse.json();
        this.cartItems = cart.items || [];
        const stock = this.stock[plan.base.id];
        if (stock?.tracked && plan.total + packsysBagsInCart(this.variants, specification, this.cartItems) > Math.max(0, stock.quantity) * 10) {
          throw new Error(this.strings.unavailable);
        }
        const items = plan.items.map((item) => ({ id: item.id, quantity: item.quantity }));
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(typeof data.description === 'string' ? data.description : this.strings.error);
        }
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        controls.forEach((control) => { control.disabled = false; });
        this.busy = false;
        this.render(false);
        this.error.hidden = false;
        this.error.textContent = (error.message && error.message !== 'Failed to fetch') ? error.message : this.strings.error;
        this.querySelector('[data-bag-cart-check]').hidden = false;
        this.form.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["packsys-roll-selector"] && !Shopify.designMode) return;
  try {
    function packsysIsRollCount(total) {
  return Number.isSafeInteger(total) && total >= 1 && total <= 1000000 && (total <= 3 || total % 4 === 0);
}

function packsysStepRollCount(value, direction) {
  if (!Number.isFinite(value) || value < 1) return 1;
  const next = direction > 0
    ? (value < 4 ? Math.floor(value) + 1 : (Math.floor(value / 4) + 1) * 4)
    : (value <= 4 ? Math.ceil(value) - 1 : (Math.ceil(value / 4) - 1) * 4);
  return Math.min(1000000, Math.max(1, next));
}

function packsysBuildRollPlan(variants, specification, total) {
  if (!packsysIsRollCount(total)) return null;
  const matching = variants.filter(function (variant) { return variant.option2 === specification; });
  const sizes = [48, 16, 4, 1];
  const items = [];
  let remaining = total;
  let price = 0;
  for (const size of sizes) {
    const quantity = Math.floor(remaining / size);
    if (!quantity) continue;
    const variant = matching.find(function (entry) { return parseInt(entry.option1, 10) === size; });
    if (!variant || !Number.isSafeInteger(variant.price) || variant.price <= 0) return null;
    items.push({ id: variant.id, quantity: quantity, size: size, variant: variant });
    price += variant.price * quantity;
    remaining %= size;
  }
  const four = matching.find(function (variant) { return parseInt(variant.option1, 10) === 4; });
  const one = matching.find(function (variant) { return parseInt(variant.option1, 10) === 1; });
  if (!four || !one || remaining || !Number.isSafeInteger(price)) return null;
  const referencePrice = Math.floor(total / 4) * four.price + (total % 4) * one.price;
  return {
    total: total,
    price: price,
    saving: Math.max(0, referencePrice - price),
    available: items.every(function (item) { return item.variant.available; }),
    items: items
  };
}

if (!customElements.get('packsys-roll-selector')) {
  customElements.define('packsys-roll-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-roll-variants]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-roll-strings]').textContent);
      this.input = this.querySelector('[data-roll-quantity]');
      this.form = this.querySelector('.packsys-rolls-form');
      this.button = this.querySelector('[data-roll-submit]');
      this.error = this.querySelector('[data-roll-error]');
      this.helpEmail = this.closest('product-info')?.querySelector('[data-packsys-help-email]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: this.dataset.currency, minimumFractionDigits: 2, maximumFractionDigits: 2
      });
      const initial = this.variants.find((variant) => String(variant.id) === this.dataset.initialVariant) || this.variants[0];
      const checked = Array.from(this.querySelectorAll('input[type="radio"]')).find((input) => input.value === initial.option2);
      if (checked) checked.checked = true;
      const requested = new URL(window.location.href).searchParams.get('rolls');
      if (requested && Number.isSafeInteger(Number(requested)) && Number(requested) > 0 && Number(requested) <= 1000000) this.input.value = requested;
      this.form.addEventListener('input', (event) => { if (event.target === this.input) this.render(true); });
      this.input.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return;
        event.preventDefault();
        this.input.value = packsysStepRollCount(Number(this.input.value), event.key === 'ArrowUp' ? 1 : -1);
        this.render(true);
      });
      this.form.addEventListener('change', (event) => { if (event.target.matches('input[type="radio"]')) this.render(true, true); });
      this.form.addEventListener('click', (event) => {
        const preset = event.target.closest('[data-roll-preset]');
        const step = event.target.closest('[data-step]');
        if (preset) this.input.value = preset.dataset.rollPreset;
        if (step) this.input.value = packsysStepRollCount(Number(this.input.value), Number(step.dataset.step));
        if (preset || step) this.render(true);
      });
      this.form.addEventListener('submit', (event) => this.addToCart(event));
      this.render(false);
    }

    text(key, replacements) {
      let result = this.strings[key];
      for (const [name, value] of Object.entries(replacements || {})) result = result.replaceAll('__' + name.toUpperCase() + '__', String(value));
      return result;
    }

    render(updateURL, updateMedia) {
      if (this.busy) return;
      const specification = this.querySelector('input[type="radio"]:checked')?.value;
      const total = Number(this.input.value);
      this.plan = packsysBuildRollPlan(this.variants, specification, total);
      const valid = !!this.plan;
      this.input.setAttribute('aria-invalid', String(!valid));
      this.error.hidden = valid;
      this.error.textContent = valid ? '' : this.strings.invalid;
      if (!valid && Number.isSafeInteger(total) && total > 4 && total < 1000000 && total % 4 !== 0) {
        this.error.textContent = this.text('invalidMultiple', { lower: Math.floor(total / 4) * 4, upper: Math.ceil(total / 4) * 4 });
      }
      this.button.disabled = !valid || !this.plan.available;
      this.querySelector('[data-roll-cart-check]').hidden = true;
      for (const preset of this.querySelectorAll('[data-roll-preset]')) {
        const size = Number(preset.dataset.rollPreset);
        preset.setAttribute('aria-pressed', String(valid && size === this.plan.total));
        const badge = preset.querySelector('[data-preset-saving]');
        if (badge) {
          const presetPlan = packsysBuildRollPlan(this.variants, specification, size);
          const percent = presetPlan ? Math.round(100 * presetPlan.saving / (presetPlan.price + presetPlan.saving)) : 0;
          badge.hidden = percent <= 0;
          badge.textContent = this.text('percent', { percent: percent });
        }
      }
      if (!valid) {
        this.querySelector('[data-roll-label]').textContent = this.strings.quantity;
        this.button.textContent = this.strings.chooseQuantity;
        this.querySelector('[data-roll-total]').textContent = '—';
        this.querySelector('[data-roll-unit]').textContent = '';
        this.querySelector('[data-roll-saving]').hidden = true;
        this.querySelector('[data-roll-packing]').textContent = '';
        this.querySelector('[data-roll-availability]').hidden = true;
        if (this.helpEmail) this.helpEmail.href = 'mailto:info@packsys.us';
        return;
      }
      const plan = this.plan;
      this.form.querySelector('[name="id"]').value = plan.items[0].id;
      this.querySelector('[data-roll-label]').textContent = plan.total === 1 ? this.strings.one : this.text('rolls', { count: plan.total });
      this.querySelector('[data-roll-total]').textContent = this.money.format(plan.price / 100) + ' ' + this.dataset.currency;
      this.querySelector('[data-roll-unit]').textContent = this.text('unit', { price: this.money.format(plan.price / plan.total / 100) });
      const saving = this.querySelector('[data-roll-saving]');
      saving.hidden = plan.saving <= 0;
      saving.textContent = this.text('saving', { amount: this.money.format(plan.saving / 100) });
      this.querySelector('[data-roll-packing]').textContent = this.text('packing', {
        packs: plan.items.map((item) => this.text('pack', { quantity: item.quantity, size: item.size })).join(' + ')
      });
      this.querySelector('[data-roll-availability]').hidden = plan.available;
      this.button.textContent = plan.total === 1 ? this.strings.addOne : this.text('add', { count: plan.total });
      if (this.helpEmail) {
        const productURL = new URL(this.dataset.productUrl, window.location.origin);
        productURL.searchParams.set('variant', plan.items[0].id);
        productURL.searchParams.set('rolls', plan.total);
        this.helpEmail.href = 'mailto:info@packsys.us?subject=' + encodeURIComponent(this.strings.quoteSubject) +
          '&body=' + encodeURIComponent(this.text('quoteBody', { specification: specification, count: plan.total, url: productURL.href }));
      }
      if (updateURL) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', plan.items[0].id);
        url.searchParams.set('rolls', plan.total);
        window.history.replaceState({}, '', url);
      }
      if (updateMedia) {
        const media = plan.items[0].variant.featured_media;
        if (media?.id) this.closest('product-info')?.querySelector('media-gallery')?.setActiveMedia?.(this.dataset.sectionId + '-' + media.id, true);
      }
    }

    async addToCart(event) {
      event.preventDefault();
      if (this.busy) return;
      this.render(false);
      if (!this.plan || !this.plan.available) { this.input.focus(); return; }
      const items = this.plan.items.map(function (item) { return { id: item.id, quantity: item.quantity }; });
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = this.strings.adding;
      this.form.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(typeof data.description === 'string' ? data.description : this.strings.error);
        }
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.busy = false;
        this.render(false);
        this.error.hidden = false;
        this.error.textContent = (error.message && error.message !== 'Failed to fetch') ? error.message : this.strings.error;
        this.querySelector('[data-roll-cart-check]').hidden = false;
        this.form.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["packsys-tape-cart-quantity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('packsys-tape-cart-quantity')) {
  customElements.define('packsys-tape-cart-quantity', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.size = Number(this.dataset.caseSize);
      this.native = this.querySelector('[data-tape-native]');
      this.rolls = this.querySelector('[data-cart-rolls]');
      this.native.hidden = true; this.querySelector('[data-tape-fallback-label]').hidden = true;
      this.querySelector('[data-tape-cart-controls]').hidden = false;
      this.addEventListener('change', event => {
        if (event.target !== this.rolls) return;
        event.stopPropagation(); this.update();
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-roll-step]'); if (!button) return;
        const value = Number(this.rolls.value), direction = Number(button.dataset.rollStep);
        this.rolls.value = Math.max(this.size, (direction > 0 ? Math.floor(value / this.size) + 1 : Math.ceil(value / this.size) - 1) * this.size);
        this.update();
      });
      this.rolls.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); this.update(); }
      });
    }
    update() {
      const total = Number(this.rolls.value), valid = Number.isSafeInteger(total) && total >= this.size && total <= this.size * 10000 && total % this.size === 0;
      this.rolls.setAttribute('aria-invalid', String(!valid));
      const error = this.querySelector('[data-roll-error]'); error.hidden = valid; error.textContent = valid ? '' : this.dataset.error;
      if (!valid) return;
      const boxes = total / this.size;
      this.querySelector('[data-roll-step="-1"]').disabled = boxes <= 1;
      if (boxes === Number(this.native.value)) return;
      this.native.value = boxes;
      this.native.dispatchEvent(new Event('change',{bubbles:true}));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["packsys-tape-selector"] && !Shopify.designMode) return;
  try {
    function packsysTapeCaseSize(variant) {
  return String(variant.id) === '53975410671923' ? 24 : 36;
}
function packsysTapeRate(cases) { return cases >= 8 ? 15 : cases >= 4 ? 10 : cases >= 2 ? 5 : 0; }
function packsysTapePlan(variant, rolls) {
  if (!variant) return null;
  const size = packsysTapeCaseSize(variant);
  if (!Number.isSafeInteger(rolls) || rolls < size || rolls > size * 10000 || rolls % size !== 0) return null;
  const cases = rolls / size, rate = variant.price > 0 ? packsysTapeRate(cases) : 0;
  const gross = variant.price * cases, saving = Math.round(gross * rate / 100);
  return { variant, rolls, size, cases, rate, gross, saving, price: gross - saving, quoted: variant.price <= 0 };
}
function packsysTapeStep(value, size, direction) {
  if (!Number.isFinite(value) || value < size) return size;
  return Math.max(size, Math.min(size * 10000, (direction > 0 ? Math.floor(value / size) + 1 : Math.ceil(value / size) - 1) * size));
}
if (!customElements.get('packsys-tape-selector')) {
  customElements.define('packsys-tape-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-tape-variants]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-tape-strings]').textContent);
      this.form = this.querySelector('form'); this.input = this.querySelector('[data-tape-rolls]');
      this.button = this.querySelector('[data-tape-submit]'); this.error = this.querySelector('[data-tape-error]');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style:'currency', currency:this.dataset.currency });
      this.variant = this.variants.find(v => String(v.id) === this.dataset.initialVariant) || this.variants[0];
      const requested = new URL(window.location.href).searchParams.get('rolls');
      if (requested !== null) this.input.value = requested;
      this.form.addEventListener('input', e => { if (e.target === this.input) this.render(true); });
      this.form.addEventListener('change', e => {
        if (!e.target.matches('input[type="radio"]')) return;
        const cases = this.plan?.cases || 1;
        this.variant = this.variants.find(v => String(v.id) === e.target.value);
        this.input.value = cases * packsysTapeCaseSize(this.variant);
        this.render(true, true);
      });
      this.form.addEventListener('click', e => {
        const preset = e.target.closest('[data-tape-cases]'), step = e.target.closest('[data-tape-step]');
        if (preset) this.input.value = Number(preset.dataset.tapeCases) * packsysTapeCaseSize(this.variant);
        if (step) this.input.value = packsysTapeStep(Number(this.input.value), packsysTapeCaseSize(this.variant), Number(step.dataset.tapeStep));
        if (preset || step) this.render(true);
      });
      this.input.addEventListener('keydown', e => {
        if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
        e.preventDefault(); this.input.value = packsysTapeStep(Number(this.input.value), packsysTapeCaseSize(this.variant), e.key === 'ArrowUp' ? 1 : -1); this.render(true);
      });
      this.form.addEventListener('submit', e => this.add(e));
      this.render(false);
    }
    text(key, values = {}) {
      let s = this.strings[key];
      for (const [key,value] of Object.entries(values)) s = s.replaceAll('__' + key.toUpperCase() + '__', String(value));
      return s;
    }
    render(updateURL, updateMedia = false) {
      if (this.busy) return;
      const size = packsysTapeCaseSize(this.variant), rolls = Number(this.input.value);
      this.input.min = size; this.input.step = size; this.input.max = size * 10000;
      this.plan = packsysTapePlan(this.variant, rolls);
      this.input.setAttribute('aria-invalid', String(!this.plan));
      this.error.hidden = !!this.plan; this.error.textContent = this.plan ? '' : this.text('invalid', { size });
      for (const step of this.querySelectorAll('[data-tape-step]')) {
        const plus = Number(step.dataset.tapeStep) > 0;
        step.textContent = (plus ? '+' : '−') + size;
        step.setAttribute('aria-label', this.text(plus ? 'increase' : 'decrease', { size }));
        step.disabled = plus ? rolls >= size * 10000 : rolls <= size;
      }
      this.querySelector('[data-tape-help]').textContent = this.text('help', { size });
      for (const preset of this.querySelectorAll('[data-tape-cases]')) {
        const cases = Number(preset.dataset.tapeCases);
        preset.querySelector('[data-preset-rolls]').textContent = this.text('rolls', { count:cases * size });
        preset.setAttribute('aria-pressed', String(this.plan?.cases === cases));
        const badge = preset.querySelector('[data-tape-badge]'); if (badge) badge.hidden = this.variant.price <= 0;
      }
      this.querySelector('[data-tape-basis]').hidden = this.variant.price <= 0;
      this.querySelector('[data-tape-cart-note]').hidden = this.variant.price <= 0;
      this.querySelector('[data-tape-cart-check]').hidden = true;
      const quote = this.querySelector('[data-tape-quote]'), availability = this.querySelector('[data-tape-availability]');
      this.button.disabled = !this.plan || this.plan.quoted || !this.variant.available;
      this.button.hidden = !!this.plan && (this.plan.quoted || !this.variant.available);
      quote.hidden = !this.plan || (!this.plan.quoted && this.variant.available);
      availability.hidden = !this.plan || (!this.plan.quoted && this.variant.available);
      availability.textContent = this.plan?.quoted ? this.strings.quoteNote : this.strings.unavailable;
      const unit = this.querySelector('[data-tape-unit]'), saving = this.querySelector('[data-tape-saving]');
      this.querySelector('[data-tape-tax]').hidden = !this.plan || this.plan.quoted;
      if (!this.plan) {
        this.querySelector('[data-tape-total]').textContent = '—'; this.querySelector('[data-tape-count]').textContent = '';
        this.querySelector('[data-tape-cases-label]').textContent = ''; unit.textContent = ''; saving.hidden = true; this.button.textContent = this.strings.choose; return;
      }
      const p = this.plan;
      this.form.querySelector('[name="id"]').value = p.variant.id;
      this.form.querySelector('[name="quantity"]').value = p.cases;
      this.querySelector('[data-tape-count]').textContent = this.text('rolls',{count:p.rolls});
      this.querySelector('[data-tape-cases-label]').textContent = this.text('packing',{cases:p.cases,size});
      this.querySelector('[data-tape-total]').textContent = p.quoted ? this.strings.quotePrice : this.money.format(p.price / 100) + ' ' + this.dataset.currency;
      unit.textContent = p.quoted ? '' : this.text('perCase',{price:this.money.format(p.price / p.cases / 100)}) + ' · ' + this.text('unit',{price:this.money.format(p.price / p.rolls / 100)});
      saving.hidden = p.saving <= 0; saving.textContent = this.text('saving',{amount:this.money.format(p.saving / 100),percent:p.rate});
      this.button.textContent = this.text('add',{count:p.rolls});
      const productURL = new URL(this.dataset.productUrl,window.location.origin); productURL.searchParams.set('variant',p.variant.id); productURL.searchParams.set('rolls',p.rolls);
      quote.href = 'mailto:info@packsys.us?subject=' + encodeURIComponent(this.strings.quoteSubject) + '&body=' + encodeURIComponent(this.text('quoteBody',{specification:p.variant.title,rolls:p.rolls,cases:p.cases,url:productURL.href}));
      const help = this.closest('product-info')?.querySelector('[data-packsys-help-email]'); if (help) help.href = quote.href;
      if (updateURL) { const url = new URL(window.location.href); url.searchParams.set('variant',p.variant.id); url.searchParams.set('rolls',p.rolls); window.history.replaceState({},'',url); }
      if (updateMedia && p.variant.featured_media?.id) this.closest('product-info')?.querySelector('media-gallery')?.setActiveMedia?.(this.dataset.sectionId + '-' + p.variant.featured_media.id,true);
    }
    async add(event) {
      event.preventDefault(); if (this.busy) return;
      this.render(false); const p = this.plan;
      if (!p || p.quoted || !p.variant.available) { this.input.focus(); return; }
      this.busy = true; this.form.setAttribute('aria-busy','true');
      const controls = Array.from(this.form.querySelectorAll('input,button')); controls.forEach(c => c.disabled = true); this.button.textContent = this.strings.adding;
      try {
        const response = await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:p.variant.id,quantity:p.cases}]})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.strings.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        controls.forEach(c => c.disabled = false); this.busy = false; this.form.removeAttribute('aria-busy'); this.render(false);
        this.error.hidden = false; this.error.textContent = error.message && error.message !== 'Failed to fetch' ? error.message : this.strings.error;
        this.querySelector('[data-tape-cart-check]').hidden = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
